import { h } from "preact";
import { forwardRef } from "preact/compat";

interface ChevronToggleProps {
  id: string;
  label: string;
  toggled?: boolean;
  onToggle?: (val: boolean) => void;
}

const ChevronToggle = forwardRef<HTMLInputElement, ChevronToggleProps>(
  ({ id, toggled, onToggle, label }, ref) => (
    <div class="ChevronToggle-container">
      <input
        ref={ref}
        class="ChevronToggle-checkbox"
        id={id}
        data-testid={id}
        type="checkbox"
        onClick={() => onToggle && onToggle(!toggled)}
        checked={toggled}
      />

      <label for={id} class="ChevronToggle-label">
        {label}
      </label>
    </div>
  )
);

export default ChevronToggle;
